import { render, staticRenderFns } from "./CbtQuestionOthers.vue?vue&type=template&id=4b52a543"
import script from "./CbtQuestionOthers.vue?vue&type=script&lang=js"
export * from "./CbtQuestionOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports